import styled from 'styled-components'

export const StyledLoadingModal = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 200;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: ${({ theme }) =>
        theme.colours.background.transparent_black};
`

export const StyledMessage = styled.p`
    color: ${({ theme }) => theme.colours.font.primary};
`

export const StyledProgressContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80%;
    max-width: 300px;
    margin-top: 16px;
`

export const StyledProgressBar = styled.div`
    width: 100%;
    height: 8px;
    background-color: ${({ theme }) => theme.colours.background.grey};
    border-radius: 4px;
    overflow: hidden;
`

export const StyledProgressFill = styled.div<{ $percent: number }>`
    height: 100%;
    width: ${({ $percent }) => $percent}%;
    background-color: ${({ theme }) => theme.colours.font.green};
    border-radius: 4px;
    transition: width 0.3s ease;
`

export const StyledProgressText = styled.p`
    color: ${({ theme }) => theme.colours.font.primary};
    font-size: 12px;
    margin-top: 8px;
    text-align: center;
`

export const StyledCancelButton = styled.button`
    margin-top: 16px;
    padding: 8px 24px;
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colours.font.primary};
    color: ${({ theme }) => theme.colours.font.primary};
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${({ theme }) => theme.colours.background.secondary};
        border-color: ${({ theme }) => theme.colours.font.primary};
        color: ${({ theme }) => theme.colours.font.primary};
    }
`
